import { makeStyles } from '@material-ui/core/styles'
import { SESSION_CHIP_VARIANTS } from 'lib/sessions/utils'

const SESSION_CHIP_COLORS = {
  [SESSION_CHIP_VARIANTS.CANCELED]: {
    backgroundColor: '#70787C',
    color: '#F6F6F6',
  },
  [SESSION_CHIP_VARIANTS.LESSON_CREDIT]: {
    backgroundColor: '#A3C1FF',
    color: '#000000',
  },
  [SESSION_CHIP_VARIANTS.PAID]: {
    backgroundColor: '#E0EAFF',
    color: '#001C57',
  },
  [SESSION_CHIP_VARIANTS.UNPAID]: {
    backgroundColor: '#EBF0F2',
    color: '#172024',
  },
}

export const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    marginBottom: '20px',
    padding: '4px 0 38px 0',
  },
  canceled: {
    color: theme.palette.text.disabled,
  },
  button: {
    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
    },
  },
  statusChip: ({ chipVariant }) => {
    const { backgroundColor, color } =
      SESSION_CHIP_COLORS[chipVariant] ||
      SESSION_CHIP_COLORS[SESSION_CHIP_VARIANTS.UNPAID]

    return {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 9999,
      padding: '2px 8px',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '16px',
      whiteSpace: 'nowrap',
      backgroundColor,
      color,
      boxShadow: 'none',
      pointerEvents: 'none',
    }
  },
  chipStyles: ({ chipVariant }) => {
    const { backgroundColor, color } =
      SESSION_CHIP_COLORS[chipVariant] ||
      SESSION_CHIP_COLORS[SESSION_CHIP_VARIANTS.UNPAID]

    return {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: 9999,
      padding: '2px 8px',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '16px',
      whiteSpace: 'nowrap',
      backgroundColor,
      color,
      boxShadow: 'none',
      pointerEvents: 'none',
    }
  },
  sessionRow: {
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '& td': {
      borderTop: '1px solid #EEEEEE',
      borderBottom: '1px solid #EEEEEE !important',
    },
    '& td:first-of-type': {
      borderLeft: '1px solid #EEEEEE',
      borderRadius: '8px 0 0 8px',
    },
    '& td:last-of-type': {
      borderRight: '1px solid #EEEEEE',
      borderRadius: '0 8px 8px 0',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
      },
    },
  },
  sessionIcon: {
    color: 'rgba(0, 35, 75, 1)',
    backgroundColor: 'rgba(244, 246, 248, 1)',
    marginRight: '15px',
    [theme.breakpoints.down('sm')]: {
      width: '64px',
      height: '64px',
      marginRight: '1rem',
    },
  },
  subtext: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  mobileText: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  mobileTop: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  mobileBottom: {
    width: '100%',
    paddingRight: '15px',
  },
  mobileContainer: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
}))
